export enum CriticalityLevel {
  Critical = 'critical',
  High = 'high',
  Medium = 'medium',
  Low = 'low'
}